import { createContext, useContext, useMemo, useState, ReactNode } from 'react';
import { FullPageLoader } from '@/components/ui';
type Ctx = {
  show: (text?: string) => void;
  hide: () => void;
  setProgress: (val: number | null) => void;
};
const LoadingCtx = createContext<Ctx | null>(null);
export function LoadingProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('Loading…');
  const [progress, setProgress] = useState<number | null>(null);
  const api = useMemo<Ctx>(
    () => ({
      show: (t) => {
        if (t) setText(t);
        setOpen(true);
      },
      hide: () => {
        setOpen(false);
        setProgress(null);
      },
      setProgress,
    }),
    []
  );
  return (
    <LoadingCtx.Provider value={api}>
      {children}
      <FullPageLoader open={open} text={text} progress={progress} />
    </LoadingCtx.Provider>
  );
}
export const useLoading = () => {
  const ctx = useContext(LoadingCtx);
  if (!ctx) throw new Error('useLoading must be used within LoadingProvider');
  return ctx;
};
